import { render, staticRenderFns } from "./DelayApprove.vue?vue&type=template&id=472b9435&scoped=true&"
import script from "./DelayApprove.vue?vue&type=script&lang=js&"
export * from "./DelayApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b9435",
  null
  
)

export default component.exports